import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ApplicationState } from '../store'
import { ResourcesAvailable } from '../store/ducks/resources/types'

function useStandardResource<T extends keyof ResourcesAvailable>(
  resource: T
): ResourcesAvailable[T] {
  const { resources } = useSelector((state: ApplicationState) => ({
    resources: state.resources[resource].list
  }))

  return useMemo(
    () =>
      (resources as Array<ResourcesAvailable[typeof resource]>).find(
        ({ standard }) => standard
      ),
    [resource, resources]
  )
}

export default useStandardResource
